
import { MessageCircle } from "lucide-react";
import { Message } from "@/types/message";
import React from "react";

export const useThreadHelpers = () => {
  // Get type icon and color for thread visualization
  const getTypeIndicator = (type: string) => {
    switch (type) {
      case 'ai':
        return { 
          icon: React.createElement(MessageCircle, { className: "h-3 w-3 text-green-500" }), 
          color: 'bg-green-500' 
        };
      case 'seller':
        return { 
          icon: React.createElement(MessageCircle, { className: "h-3 w-3 text-orange-500" }), 
          color: 'bg-orange-500' 
        };
      case 'user':
        return { 
          icon: React.createElement(MessageCircle, { className: "h-3 w-3 text-blue-500" }), 
          color: 'bg-blue-500' 
        };
      default:
        return { 
          icon: React.createElement(MessageCircle, { className: "h-3 w-3 text-gray-500" }), 
          color: 'bg-gray-500' 
        };
    }
  };

  // Helper function to get summary text for collapsed messages
  const getMessageSummary = (message: Message): string => {
    // Get first 40 characters of content
    const contentPreview = message.content.slice(0, 40) + (message.content.length > 40 ? "..." : "");
    return contentPreview;
  };
  
  return {
    getTypeIndicator,
    getMessageSummary
  };
};
